import { FC, ReactNode, useEffect, useState } from 'react';
import Footer from './footer';
import Header from './header';
import { NoLogin, Toast } from '..';
import { GlobalModal } from './global-modal';
import { useLocation } from '@tanstack/react-router';
import Header2 from './header2';
import Footer2 from './footer2';
import Header_type3 from './header_type3';
import GnbMenu from './gnbMenu';
import { useLoginStore, usePersistStore, usePopupStore } from '@/shared/lib/store';
import Loading from '../loading/loading';
import { useCreateStore } from '@/entities/create';
import { LoginCheck } from '@/features/auth';

interface MainLayoutProps {
    children: ReactNode;
}

export const MainLayout: FC<MainLayoutProps> = ({ children }) => {
    const location = useLocation();
    const isPod = location.pathname.includes('sets/pod');
    const isPodV2 = location.pathname.replace(/\/$/, '') === '/sets/pod-v2';
    const isPublish = location.pathname.includes('/publish/') || location.pathname === '/publish';
    const isDirect = location?.search?.direct === 'y';
    const isReportTeacher = location.pathname.includes('/report/eval/t');
    const isEval = !isReportTeacher && location.pathname.toLowerCase().includes('eval');
    const isHomeowrk = isEval || location.pathname.toLowerCase().includes('homework');

    const isImportHeader = location.pathname.toLocaleLowerCase().includes('edit');
    const { type } = useCreateStore();
    const { loginInfo, memberInfo } = useLoginStore();
    usePersistStore.getState().printValues();
    const { hideForever, hideUntil } = usePopupStore();

    const [showReport, setShowReport] = useState(false);
    const [checked, setChecked] = useState<string[]>([]);

    useEffect(() => {
        // hideForever가 true이면 항상 숨김
        if (hideForever) {
            setShowReport(false);
            return;
        }
        // hideUntil이 없거나, 현재 날짜가 hideUntil보다 크면 표시
        if (!hideUntil || new Date() > new Date(hideUntil)) {
            setShowReport(true);
        }
    }, [hideForever, hideUntil]);

    return (
        <>
            {/* NOTE: 업데이트 팝업 내역, 비슷한 작업시 해당 팝업 변경 사용! */}
            {/* {showReport && (!isHomeowrk || isImportHeader) && (
                <UpdatePopup
                    checked={checked}
                    setChecked={setChecked}
                    setShowReport={setShowReport}
                />
            )} */}
            <LoginCheck />
            {isImportHeader ? (
                <>
                    <Header_type3>
                        <GnbMenu />
                    </Header_type3>
                    <div
                        className={`ki-main-contents isScrollView ttukttak ${type === 'editMode' ? 'type3_conts' : 'type2_conts'}`}
                    >
                        {children}
                        <Loading />
                        <Toast />
                        <GlobalModal />
                        <Footer2 />
                    </div>
                </>
            ) : !isHomeowrk ? (
                <>
                    {!(location.pathname.includes('edit') || isPod) && (
                        <Header isDirect={isDirect} />
                    )}
                    <div
                        className={`ki-main-contents isScrollView ttukttak scl ${isPod ? 'type3_conts' : ''} ${isPodV2 ? 'pod-v2-layout' : ''}`}
                    >
                        {children}
                        <a
                            href="#"
                            onClick={(e) => e.preventDefault()}
                            className="gotop"
                            id="btn-top"
                        >
                            <span className="blind">TOP</span>
                        </a>
                        <Loading />
                        <Toast />
                        <Footer />
                        <GlobalModal />
                        {(loginInfo?.loginYn === 'N' ||
                            (memberInfo.typeCode !== '' &&
                                !(
                                    memberInfo.typeCode === '0' ||
                                    memberInfo.typeCode === '1' ||
                                    memberInfo.typeCode === '2'
                                ))) &&
                            !isPublish && <NoLogin />}
                    </div>
                </>
            ) : (
                <>
                    <Header2 isDirect={isDirect} />
                    <div className="ki-main-contents isScrollView ttukttak type3_conts mobile">
                        <section className="contwrap">{children}</section>
                        <Toast />
                        <Footer2 />
                        <GlobalModal />
                        {/* {sIsLogin === 'N' && <NoLogin />} */
                        /* 학생 입장용 평가에는 필요없을것같아서 주석처리(PES) */}
                    </div>
                </>
            )}
        </>
    );
};
